import { getWord } from './declination-word'

const getTimeStringValue = (value) => {
  return value >= 10 ? value : `0${value}`;
};

const getUniversalBannerTimerParams = (leftTime) => {
  let sec = leftTime / 1000;
  let min = sec / 60;
  let hours = min / 60;
  let days = hours / 24;

  days = Math.floor(days);
  hours = Math.floor(hours - (days * 24));
  min = Math.floor(min - (hours * 60) - (days * 1440));
  sec = Math.floor(sec - (min * 60) - (hours * 3600) - (days * 86400));

  return {
    days: days,
    hours: hours,
    minutes: min,
    seconds: sec
  }
};

const setUniversalBannerTimerFields = (timerParams, daysField, hoursField, minutesField, secondsField) => {
  const { days, hours, minutes, seconds } = timerParams;

  daysField.textContent = `${days} ${getWord('day', days)}`
  hoursField.textContent = getTimeStringValue(hours);
  minutesField.textContent = getTimeStringValue(minutes);
  secondsField.textContent = getTimeStringValue(seconds);
};

const universalBannerTimerInit = (timer, timerParams) => {
  const daysField = timer.querySelector('.js-universal-notice-days');
  const hoursField = timer.querySelector('.js-universal-notice-hours');
  const minutesField = timer.querySelector('.js-universal-notice-minutes');
  const secondsField = timer.querySelector('.js-universal-notice-seconds');

  let interval = null;

  setUniversalBannerTimerFields(timerParams, daysField, hoursField, minutesField, secondsField);
  timer.classList.add('js-universal-notice-active');

  interval = setInterval(() => {

    if (timerParams.seconds) {
      --timerParams.seconds;
    } else if (timerParams.minutes) {
      --timerParams.minutes;
      timerParams.seconds = 59;
    } else if (timerParams.hours) {
      --timerParams.hours;
      timerParams.minutes = 59;
    } else if (timerParams.days) {
      --timerParams.days;
      timerParams.hours = 24;
    } else {
      clearInterval(interval);
      timer.classList.remove('js-universal-notice-active')
    }

    setUniversalBannerTimerFields(timerParams, daysField, hoursField, minutesField, secondsField);

  }, 1000);
};

export { universalBannerTimerInit, getUniversalBannerTimerParams }
